export const ROOT_ROUTE = "/"

export const ACCESS_DENIED_ROUTE = "/access-denied"

export const LOGIN_ROUTE = "/login"
export const AUTH_PASSWORD_ROUTE = `${LOGIN_ROUTE}/password`
export const FORGOT_PASSWORD_ROUTE = `${LOGIN_ROUTE}/forgot-password`
export const ACTIVATION_CODE_ROUTE = `${LOGIN_ROUTE}/activation-code`
export const CREATE_PASSWORD_ROUTE = `${LOGIN_ROUTE}/create-password`
export const INVITATION_ROUTE = `${LOGIN_ROUTE}/invitation`

export const OFFICE_MANAGER_ROUTE = "/office"
export const PURCHASES_ROUTE = `${OFFICE_MANAGER_ROUTE}/purchases`

export const MERCHANT_ROUTE = "/merchant"
export const MERCHANT_REPORTS_ROUTE = `${MERCHANT_ROUTE}/reports`
export const CONTROL_KITCHEN_ROUTE = `${MERCHANT_REPORTS_ROUTE}/control-kitchen`
export const SURVEY_ROUTE = `${MERCHANT_REPORTS_ROUTE}/survay`
export const ROLLUP_GRAPH_EXAMPLE_ROUTE = `${MERCHANT_REPORTS_ROUTE}/rollup-graph-example`

export const MERCHANT_ADMIN_ROUTE = `${MERCHANT_ROUTE}/admin`
export const MERCHANT_NEWS_ROUTE = `${MERCHANT_ADMIN_ROUTE}/news`
export const MERCHANT_CREATE_NEWS_ROUTE = `${MERCHANT_ADMIN_ROUTE}/news/create`


export const PROFILE_ROUTE = "/profile"
export const SETTINGS_ROUTE = "/settings"
export const NEWS_ROUTE = "/news"

export const ERROR_ROUTE = "/error"



// Removes the prefix from the entire route
export function getAsRoute(prefix: string, route: string) {
    const subRoute = route.substring(prefix.length + 1)
    console.log(`Placing sub route ${subRoute} with prefix ${prefix} at: ${route}`)
    return subRoute
}
